import { z } from 'zod';
import { uuid } from './common.js';
/**
 * Danger Zone (F10 settings page — no FEATURES.md spec exists for this;
 * designed fresh, see `apps/server/src/account/handlers.ts`'s top-of-file
 * comment for the full scope writeup). Two self-service, owner-scoped-only
 * ops: `account.delete` (typed two-field confirmation, synchronous) and
 * `account.exportData` (fire-and-forget async job, platform.md "slow/
 * external work is a 202 job, never a blocking request").
 */
/**
 * `account.delete` — BOTH fields must match the caller's OWN current
 * `users` row (never a client-supplied target id; self-service only,
 * `apps/server/src/account/handlers.ts` re-reads `conn.userId`'s row
 * server-side). `confirmEmail` is compared case-insensitively (email
 * addresses are conventionally case-insensitive); `confirmDisplayName` is
 * compared exactly as typed (ux.md "typed confirmation naming the
 * resource") against `users.displayName ?? users.email` — the SAME
 * null-displayName fallback `ProfileSection.tsx` already uses to label an
 * account that never set a display name, so a user without one still has a
 * well-defined resource name to type instead of a confirmation that can
 * never pass.
 */
export const accountDeleteInput = z.object({
    confirmDisplayName: z.string().trim().min(1, 'errors:account.delete.confirmDisplayName.required'),
    confirmEmail: z.string().trim().email('errors:account.delete.confirmEmail.invalid'),
});
/**
 * `deleted: true` on both a fresh delete AND a replayed call against an
 * already-`status='deleted'` account (idempotent no-op — see the handler's
 * doc comment) — the caller can't distinguish the two from this shape alone,
 * which is intentional: either way, the account is (now) deleted.
 */
export const accountDeleteResult = z.object({ deleted: z.boolean() });
/** `account.exportData` — no input fields; always the CALLER's own data. */
export const accountExportDataInput = z.object({});
export const accountExportDataResult = z.object({ jobId: uuid });
